(function () {
    'use strict';

    angular.module("imApp").factory("operationService", ['$ihttp', function ($ihttp) {
        let service = {
            getOperation: function (parms) {
                return $ihttp.post({
                    method: 266,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 381,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
